module.exports = __webpack_public_path__ + "img/20200306163403120.0847a03b.jpg";